import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const IdCardIcon: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <mask
        id="mask0_108_2143"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_108_2143)">
        <path
          d="M14.1538 12.4615H18.2308V11.4615H14.1538V12.4615ZM14.1538 9.69225H18.2308V8.69225H14.1538V9.69225ZM5.76925 15.3077H12.3845V15.1423C12.3845 14.5589 12.0916 14.1073 11.5058 13.7875C10.9199 13.4677 10.1103 13.3077 9.077 13.3077C8.04367 13.3077 7.234 13.4677 6.648 13.7875C6.06217 14.1073 5.76925 14.5589 5.76925 15.1423V15.3077ZM9.077 11.6923C9.49867 11.6923 9.85408 11.5478 10.1433 11.2588C10.4324 10.9696 10.577 10.6141 10.577 10.1923C10.577 9.77042 10.4324 9.415 10.1433 9.126C9.85408 8.83683 9.49867 8.69225 9.077 8.69225C8.65517 8.69225 8.29967 8.83683 8.0105 9.126C7.7215 9.415 7.577 9.77042 7.577 10.1923C7.577 10.6141 7.7215 10.9696 8.0105 11.2588C8.29967 11.5478 8.65517 11.6923 9.077 11.6923ZM4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H19.3845C19.8448 5 20.2292 5.15417 20.5375 5.4625C20.8458 5.77083 21 6.15517 21 6.6155V17.3845C21 17.8448 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8448 19 19.3845 19H4.6155ZM4.6155 18H19.3845C19.5385 18 19.6796 17.9359 19.8078 17.8077C19.9359 17.6796 20 17.5385 20 17.3845V6.6155C20 6.4615 19.9359 6.32042 19.8078 6.19225C19.6796 6.06408 19.5385 6 19.3845 6H4.6155C4.4615 6 4.32042 6.06408 4.19225 6.19225C4.06408 6.32042 4 6.4615 4 6.6155V17.3845C4 17.5385 4.06408 17.6796 4.19225 17.8077C4.32042 17.9359 4.4615 18 4.6155 18Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default IdCardIcon;
